import React from 'react';
import { useNavigate } from 'react-router-dom';

import { EssayType } from '@/application/interfaces/pegasus.gateway';

import IconComponent from '../../../../components/icon/icon';
import {
  Card,
  ContentWrapper,
  Description,
  DetailsButton,
  Score,
  ScoreLabel,
  TagWrapper,
  Title,
} from './styles';

type Props = {
  essayGuid: string;
  essayStatus?: EssayType | string;
  essayTitle: string;
  essayDescription: string;
  essayScore?: number;
};

export enum essayStatusEnum {
  DRAFT = 'RASCUNHO',
  SENT = 'AGUARDANDO CORREÇÃO',
  DONE = 'CORRIGIDA',
}

const EssayItem: React.FC<Props> = ({
  essayGuid,
  essayStatus,
  essayTitle,
  essayDescription,
  essayScore,
}) => {
  const navigate = useNavigate();

  const convertStrToEnum = (convertingStr: string): essayStatusEnum => {
    switch (convertingStr) {
      case 'DRAFT':
        return essayStatusEnum.DRAFT;
      case 'SENT':
        return essayStatusEnum.SENT;
      case 'DONE':
        return essayStatusEnum.DONE;
    }
  };

  const enumEssayStatus = convertStrToEnum(essayStatus);

  return (
    <Card>
      <ContentWrapper>
        <div>
          <TagWrapper essayStatus={enumEssayStatus}>
            <span>{enumEssayStatus}</span>
          </TagWrapper>
          <Title>{essayTitle}</Title>
          {essayScore && <Description>{essayDescription}</Description>}
        </div>
        {essayScore && (
          <div>
            <ScoreLabel>Sua nota</ScoreLabel>
            <Score>
              {essayScore}
              <span>/1000</span>
            </Score>
          </div>
        )}
      </ContentWrapper>
      <DetailsButton
        type="button"
        onClick={() => {
          if (enumEssayStatus === essayStatusEnum.DRAFT) {
            navigate(`/essays/write/${essayGuid}`);
            return;
          }
          navigate(`/essays/feedback/${essayGuid}`);
        }}
      >
        Ver detalhes
        <IconComponent name="whiteArrow" />
      </DetailsButton>
    </Card>
  );
};

export default EssayItem;
